<template>
    <div class="my-picker">
        <mt-cell :title="value?value:placeholder" is-link @click.native="popuVisible=true" :style="{'color':value?'black':'#888'}">
        </mt-cell>
        <mt-popup class="mtpopu" v-model="popuVisible" position="bottom" popup-transition="popup-fade">
            <div class="popu-btn">
                <label style="color:#606060;" @click="cancel">取消</label>
                <label style="color:#276CE0;" @click="confirm">确定</label>
            </div>
            <mt-picker :slots="slots" :valueKey="vkey" @change="onValuesChange" :itemHeight="itemHeight" :visibleItemCount="visibleItemCount"></mt-picker>
        </mt-popup>
    </div>
</template>
<script>
export default {
    name:"picker",
    props:{
        value:{},
        arr:{},
        vkey:{},
        placeholder:{
            type:String,
            default:"请选择"
        }
    },
    data(){
        return{
            popuVisible:false,
            itemHeight:50,
            visibleItemCount:3,
            slots: [{values:[]}],
            pickerValue:"",
        }
    },
    mounted(){
        this.slots[0].values=this.arr;
    },
    methods:{
        onValuesChange(picker,values){
            this.pickerValue=values[0];
        },
        cancel(){
            this.popuVisible=false;
            this.pickerValue=this.pickerValue;
        },
        confirm(){
            this.popuVisible=false;
            this.$emit("bindChange",{"values":this.pickerValue});
        },
    },
}
</script>

<style lang="scss" scoped>
.mint-popup >>>.picker-slot,.mint-popup >>>.picker-slot-center{
    width: 100%;
}
</style>

<style scoped>
.mtpopu{width: 100%;}
.popu-btn{display: flex;justify-content: space-between;align-items: center;padding: 30px;font-size: 16px;}
.p-title .mint-cell-title{
    width: 10%;
}
.my-picker{position: absolute;right: 0;top:0;width: 76%;box-sizing: border-box;color: black;}
</style>


// WEBPACK FOOTER //
// src/components/common/picker.vue